module.exports = __webpack_public_path__ + "static/odnova-d28c1fe2886f0e08516b5a3d601a46c8.png";